import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "../../store/actions";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";

function HomeAhorro(props) {
  const dispatch = useDispatch();

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);

  const { historia } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(CMSActions.getHistoria());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defRoute = rutas?.filter((route) => route?.name === "AhorroCredito");

  const historyItems = (
    <>
      {historia &&
        historia?.aCHistoria?.map((item, index) => (
          <TextoYTitulo
            key={index}
            title={item.titulo}
            text={item.descripcion?.html}
            borderTopColor="#D7DE00"
          />
        ))}
    </>
  );

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      {historyItems}
    </>
  );
}

export default HomeAhorro;
